const getTvPackages = ({ tvPackageState }) => tvPackageState.tvPackages;

export { getTvPackages };
